import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import history from "./history";
import App from "./App";
import store from "./redux/store";

// import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.min.css";

 

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} basename="/riders-portal/dashboard">
      <div>
        <App />
      </div>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register();
